import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { StudentProfileView } from "@/components/profile/StudentProfileView";
import { StudentEditorDialog } from "@/components/StudentEditorDialog";

export default function StudentProfilePage() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(null);
  const [opts, setOpts] = useState({ classes: [], buses: [] });
  const [refreshKey, setRefreshKey] = useState(0);

  const openEdit = async (s) => {
    const [c, b] = await Promise.all([api.get("/classes"), api.get("/buses")]);
    setOpts({ classes: c.data, buses: b.data });
    setEditing(s);
  };

  return (
    <>
      <StudentProfileView studentId={studentId} backLabel="Back to list" onBack={() => navigate("/admin/students")} onEdit={openEdit} refreshKey={refreshKey} />
      {editing && (
        <StudentEditorDialog student={editing} classes={opts.classes} buses={opts.buses} onClose={() => setEditing(null)} onSaved={() => setRefreshKey((k) => k + 1)} />
      )}
    </>
  );
}
